import React, { useState } from 'react';

function Collections({ handleMouseMove, handleMouseLeave, handleCardMove, handleCardLeave, openModal }) {
  const [selectedCategory, setSelectedCategory] = useState('rings');
  const [searchTerm, setSearchTerm] = useState('');

  const products = {
    rings: [
      { id: 1, name: 'Diamond Solitaire', price: '$2,499', description: 'Timeless Elegance', model: 'https://modelviewer.dev/shared-assets/models/Astronaut.glb' },
      { id: 2, name: 'Gold Band', price: '$1,299', description: 'Pure Luxury', model: 'https://modelviewer.dev/shared-assets/models/Astronaut.glb' },
      { id: 3, name: 'Sapphire Ring', price: '$1,899', description: 'Regal Beauty', model: 'https://modelviewer.dev/shared-assets/models/Astronaut.glb' },
      { id: 4, name: 'Emerald Ring', price: '$2,199', description: 'Exotic Charm', model: 'https://modelviewer.dev/shared-assets/models/Astronaut.glb' },
    ],
    necklaces: [
      { id: 5, name: 'Pearl Pendant', price: '$1,599', description: 'Sophisticated Grace' },
      { id: 6, name: 'Gold Chain', price: '$899', description: 'Minimalist Chic' },
      { id: 7, name: 'Crystal Necklace', price: '$1,399', description: 'Brilliant Radiance' },
      { id: 8, name: 'Silver Locket', price: '$699', description: 'Sentimental Treasure' },
    ],
    bracelets: [
      { id: 9, name: 'Diamond Bracelet', price: '$2,999', description: 'Spectacular Shine' },
      { id: 10, name: 'Gold Bangle', price: '$1,199', description: 'Classic Prestige' },
      { id: 11, name: 'Beaded Bracelet', price: '$499', description: 'Artisan Craft' },
      { id: 12, name: 'Tennis Bracelet', price: '$2,499', description: 'Refined Brilliance' },
    ],
    earrings: [
      { id: 13, name: 'Diamond Studs', price: '$1,899', description: 'Essential Sparkle' },
      { id: 14, name: 'Pearl Drops', price: '$699', description: 'Delicate Allure' },
      { id: 15, name: 'Gold Hoops', price: '$599', description: 'Timeless Statement' },
      { id: 16, name: 'Emerald Dangles', price: '$999', description: 'Vibrant Elegance' },
    ],
  };

  return (
    <section id="collections" className="bg-gray-950 py-32">
      <div className="luxury-container">
        <h2 className="text-center text-luxury text-5xl mb-4 tracking-widest hover-glow">
          OUR COLLECTIONS
        </h2>
        <p className="text-center text-gray-400 text-lg mb-16 tracking-wide hover-glow">Explore our finest curated collections</p>

        {/* Bridal Collection Hero */}
        <div className="bg-gradient-to-r from-yellow-600/10 via-transparent to-yellow-600/10 py-16 rounded-lg border border-yellow-600/20 mb-16">
          <div className="text-center">
            <h3 className="text-4xl font-bold text-yellow-400 mb-4 hover-glow">❦ BRIDAL COLLECTION</h3>
            <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
              Discover engagement rings and wedding bands crafted for eternal love.
              Each piece tells a story of commitment and timeless elegance.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => setSelectedCategory('rings')}
                className="bg-yellow-600 hover:bg-yellow-500 text-black font-semibold px-8 py-3 rounded transition-colors"
              >
                ENGAGEMENT RINGS
              </button>
              <button
                onClick={() => setSelectedCategory('rings')}
                className="border border-yellow-600 text-yellow-400 hover:bg-yellow-600 hover:text-black font-semibold px-8 py-3 rounded transition-colors"
              >
                WEDDING BANDS
              </button>
            </div>
          </div>
        </div>

        {/* Search Bar */}
        <div className="flex justify-center mb-12">
          <div className="relative w-full max-w-md">
            <input
              type="text"
              placeholder="Search collections..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-3 bg-gray-900 border border-yellow-600/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500/50"
            />
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-yellow-500">
              ❖
            </div>
          </div>
        </div>
        
        {/* Category Buttons */}
        <div className="flex justify-center gap-6 mb-20 flex-wrap">
          {Object.keys(products).map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-8 py-3 rounded-sm font-semibold text-sm tracking-widest transform-gpu transition-transform duration-75 cursor-pointer ${
                selectedCategory === category
                  ? 'bg-gradient-to-r from-yellow-600 to-yellow-700 text-gray-900 shadow-lg depth-effect'
                  : 'bg-gray-900 text-yellow-400 hover:bg-gray-800 border border-yellow-600/50'
              }`}
              onMouseMove={(e) => handleMouseMove(e, e.currentTarget)}
              onMouseLeave={(e) => handleMouseLeave(e.currentTarget)}
            >
              {category.toUpperCase()}
            </button>
          ))}
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {products[selectedCategory]
            .filter(product => 
              product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
              product.description.toLowerCase().includes(searchTerm.toLowerCase())
            )
            .map((product, index) => (
            <div
              key={product.id}
              className="card-luxury-3d p-8 rounded-sm depth-effect group"
              onMouseMove={(e) => handleCardMove(e, e.currentTarget)}
              onMouseLeave={(e) => handleCardLeave(e.currentTarget)}
            >
              <div className="h-32 mb-6 flex items-center justify-center bg-gradient-to-br from-yellow-600/10 to-transparent rounded-sm transition-transform duration-300">
                <div className="text-6xl font-bold text-yellow-600/30">
                  {String(product.id).padStart(2, '0')}
                </div>
              </div>

              <div className="card-content" onMouseMove={(e) => handleCardMove(e, e.currentTarget)} onMouseLeave={(e) => handleCardLeave(e?.currentTarget)}>
                <h3 
                  className="text-xl font-bold text-yellow-400 mb-2 tracking-wide transform-gpu transition-transform duration-75 cursor-pointer"
                >
                  {product.name}
                </h3>
                <p 
                  className="text-gray-400 text-sm mb-4 tracking-wider font-light transform-gpu transition-transform duration-75 cursor-pointer"
                >
                  {product.description}
                </p>
                <p 
                  className="text-2xl font-bold text-yellow-500 mb-6 tracking-wide transform-gpu transition-transform duration-75 cursor-pointer"
                >
                  {product.price}
                </p>
                <button 
                  className="w-full bg-gray-900 hover:bg-gray-800 text-yellow-400 border border-yellow-600/50 hover:border-yellow-400 py-3 rounded-sm font-semibold transform-gpu transition-transform duration-75 cursor-pointer tracking-widest text-sm"
                  onClick={(e) => openModal(product, e.currentTarget)}
                >
                  VIEW DETAILS
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Collections;
